import assignmentService from 'ApiService/Student/assignmentService';
import TestComponent from '../Index';

const Index = () => {
  const title = 'No End Assignment Assigned Yet.';
  const fetchEndAssignment = async () => {
    return await assignmentService.getEndAssignment();
  };
  return <TestComponent fetchTests={fetchEndAssignment} NoData={title} />;
};

export default Index;
